<div class="seccion-media">
  <form [formGroup]="loginForm" class="login-form" autocomplete="on">
    <p>
      <label for="username">Username:</label>
      <input id="username" formControlName="username" type="text" autocomplete="on" />
    </p>
    <p>
      <label for="password">Password:</label>
      <input id="password" formControlName="password" type="password" autocomplete="on" />
    </p>
    <p>
      <span class="error">{{ mensaje }}</span>
    </p>
  </form>
  <p>
    <button (click)="login()">login</button>
  </p>
</div>